var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2221_16273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.305 40.59C31.2845 40.59 40.1852 31.6893 40.1852 20.7098C40.1852 9.73026 31.2845 0.82959 20.305 0.82959C9.32548 0.82959 0.424805 9.73026 0.424805 20.7098C0.424805 31.6893 9.32548 40.59 20.305 40.59Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9427 17.4405H7.38149C6.55716 17.4405 5.88892 18.1087 5.88892 18.9331V24.9489C5.88892 25.7732 6.55716 26.4414 7.38149 26.4414H34.9427C35.767 26.4414 36.4353 25.7732 36.4353 24.9489V18.9331C36.4353 18.1087 35.767 17.4405 34.9427 17.4405Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8992 24.6452C33.3864 24.6452 34.592 23.4396 34.592 21.9524C34.592 20.4652 33.3864 19.2595 31.8992 19.2595C30.4119 19.2595 29.2063 20.4652 29.2063 21.9524C29.2063 23.4396 30.4119 24.6452 31.8992 24.6452Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9427 27.7876H7.38149C6.55716 27.7876 5.88892 28.4558 5.88892 29.2802V35.296C5.88892 36.1203 6.55716 36.7885 7.38149 36.7885H34.9427C35.767 36.7885 36.4353 36.1203 36.4353 35.296V29.2802C36.4353 28.4558 35.767 27.7876 34.9427 27.7876Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8992 34.9928C33.3864 34.9928 34.592 33.7872 34.592 32.3C34.592 30.8128 33.3864 29.6071 31.8992 29.6071C30.4119 29.6071 29.2063 30.8128 29.2063 32.3C29.2063 33.7872 30.4119 34.9928 31.8992 34.9928Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9427 7.09265H7.38149C6.55716 7.09265 5.88892 7.7609 5.88892 8.58522V14.601C5.88892 15.4253 6.55716 16.0936 7.38149 16.0936H34.9427C35.767 16.0936 36.4353 15.4253 36.4353 14.601V8.58522C36.4353 7.7609 35.767 7.09265 34.9427 7.09265Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8992 14.2977C33.3864 14.2977 34.592 13.0921 34.592 11.6049C34.592 10.1176 33.3864 8.91199 31.8992 8.91199C30.4119 8.91199 29.2063 10.1176 29.2063 11.6049C29.2063 13.0921 30.4119 14.2977 31.8992 14.2977Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8765 11.5711C32.0926 11.5711 32.2679 11.3959 32.2679 11.1798C32.2679 10.9636 32.0926 10.7884 31.8765 10.7884C31.6603 10.7884 31.4851 10.9636 31.4851 11.1798C31.4851 11.3959 31.6603 11.5711 31.8765 11.5711Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9229 11.139C32.9229 11.5323 32.4393 12.4882 32.1296 13.0603C32.0205 13.261 31.7326 13.261 31.6241 13.0603C31.3144 12.4882 30.8308 11.5323 30.8308 11.139C30.8308 10.5613 31.2995 10.0927 31.8772 10.0927C32.4549 10.0927 32.9235 10.5613 32.9235 11.139H32.9229Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0042 10.6986C31.2203 10.6986 31.3955 10.5234 31.3955 10.3073C31.3955 10.0911 31.2203 9.91589 31.0042 9.91589C30.788 9.91589 30.6128 10.0911 30.6128 10.3073C30.6128 10.5234 30.788 10.6986 31.0042 10.6986Z",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0507 10.2667C32.0507 10.6599 31.5671 11.6166 31.2574 12.188C31.1483 12.3893 30.8604 12.3893 30.752 12.188C30.4422 11.6166 29.958 10.6599 29.958 10.2667C29.958 9.68899 30.4267 9.22034 31.0044 9.22034C31.5821 9.22034 32.0507 9.68899 32.0507 10.2667ZM31.3957 10.3072C31.3957 10.091 31.2206 9.91583 31.0044 9.91583C30.7881 9.91583 30.613 10.091 30.613 10.3072C30.613 10.5235 30.7881 10.6986 31.0044 10.6986C31.2206 10.6986 31.3957 10.5235 31.3957 10.3072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5621 28.4077V34.4235C35.5621 35.2442 34.8909 35.916 34.0695 35.916H6.50893C5.68755 35.916 5.01636 35.2442 5.01636 34.4235V28.4077C5.01636 27.5869 5.68755 26.9151 6.50893 26.9151H34.0695C34.8909 26.9151 35.5621 27.5869 35.5621 28.4077ZM33.7199 31.4277C33.7199 29.9401 32.514 28.7342 31.0264 28.7342C29.5388 28.7342 28.3335 29.9401 28.3335 31.4277C28.3335 32.9153 29.5388 34.1206 31.0264 34.1206C32.514 34.1206 33.7199 32.9147 33.7199 31.4277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5621 18.0606V24.0757C35.5621 24.8971 34.8909 25.5683 34.0695 25.5683H6.50893C5.68755 25.5683 5.01636 24.8971 5.01636 24.0757V18.0606C5.01636 17.2392 5.68755 16.568 6.50893 16.568H34.0695C34.8909 16.568 35.5621 17.2392 35.5621 18.0606ZM33.7199 21.08C33.7199 19.5924 32.514 18.3865 31.0264 18.3865C29.5388 18.3865 28.3335 19.5924 28.3335 21.08C28.3335 22.5676 29.5388 23.7729 31.0264 23.7729C32.514 23.7729 33.7199 22.5676 33.7199 21.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5621 7.71297V13.7288C35.5621 14.5495 34.8909 15.2213 34.0695 15.2213H6.50893C5.68755 15.2213 5.01636 14.5495 5.01636 13.7288V7.71297C5.01636 6.89221 5.68755 6.2204 6.50893 6.2204H34.0695C34.8909 6.2204 35.5621 6.89221 35.5621 7.71297ZM33.7199 10.7324C33.7199 9.24543 32.514 8.03953 31.0264 8.03953C29.5388 8.03953 28.3335 9.24543 28.3335 10.7324C28.3335 12.2194 29.5388 13.4259 31.0264 13.4259C32.514 13.4259 33.7199 12.22 33.7199 10.7324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0266 8.03943C32.5142 8.03943 33.7201 9.24533 33.7201 10.7323C33.7201 12.2193 32.5142 13.4258 31.0266 13.4258C29.539 13.4258 28.3337 12.2199 28.3337 10.7323C28.3337 9.2447 29.539 8.03943 31.0266 8.03943ZM31.2572 12.1881C31.5669 11.6166 32.0505 10.66 32.0505 10.2668C32.0505 9.68905 31.5825 9.2204 31.0042 9.2204C30.4258 9.2204 29.9578 9.68905 29.9578 10.2668C29.9578 10.66 30.442 11.6166 30.7518 12.1881C30.8602 12.3894 31.1481 12.3894 31.2572 12.1881Z",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0266 18.3864C32.5142 18.3864 33.7201 19.5923 33.7201 21.0798C33.7201 22.5674 32.5142 23.7727 31.0266 23.7727C29.539 23.7727 28.3337 22.5674 28.3337 21.0798C28.3337 19.5923 29.539 18.3864 31.0266 18.3864Z",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0266 28.7342C32.5142 28.7342 33.7201 29.9401 33.7201 31.4277C33.7201 32.9153 32.5142 34.1205 31.0266 34.1205C29.539 34.1205 28.3337 32.9146 28.3337 31.4277C28.3337 29.9407 29.539 28.7342 31.0266 28.7342Z",
    fill: "#EF5323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0695 16.568H6.50893C5.68461 16.568 5.01636 17.2362 5.01636 18.0606V24.0757C5.01636 24.9001 5.68461 25.5683 6.50893 25.5683H34.0695C34.8938 25.5683 35.5621 24.9001 35.5621 24.0757V18.0606C35.5621 17.2362 34.8938 16.568 34.0695 16.568Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 18.9534H13.3081",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 21.08H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 23.2063H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7201 21.0798C33.7201 22.5674 32.5142 23.7727 31.0266 23.7727C29.539 23.7727 28.3337 22.5674 28.3337 21.0798C28.3337 19.5923 29.539 18.3864 31.0266 18.3864C32.5142 18.3864 33.7201 19.5923 33.7201 21.0798Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5547 21.159L30.5618 22.1667",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5579 22.1704L30.5616 22.1667L32.4985 20.2291",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0695 35.916H6.50893C5.68755 35.916 5.01636 35.2442 5.01636 34.4235V28.4077C5.01636 27.5869 5.68755 26.9151 6.50893 26.9151H34.0695C34.8909 26.9151 35.5621 27.5869 35.5621 28.4077V34.4235C35.5621 35.2442 34.8909 35.916 34.0695 35.916Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 29.3013H13.3081",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 31.4278H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 33.5534H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7201 31.4277C33.7201 32.9146 32.5142 34.1205 31.0266 34.1205C29.539 34.1205 28.3337 32.9146 28.3337 31.4277C28.3337 29.9407 29.539 28.7342 31.0266 28.7342C32.5142 28.7342 33.7201 29.9401 33.7201 31.4277Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5547 31.5066L30.5618 32.5137",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5579 32.5176L30.5616 32.5139L32.4985 30.577",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0695 15.2213H6.50893C5.68755 15.2213 5.01636 14.5495 5.01636 13.7288V7.71297C5.01636 6.89221 5.68755 6.2204 6.50893 6.2204H34.0695C34.8909 6.2204 35.5621 6.89221 35.5621 7.71297V13.7288C35.5621 14.5495 34.8909 15.2213 34.0695 15.2213Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 8.60632H13.3081",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 10.7322H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73291 12.8587H23.7972",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7201 10.7323C33.7201 12.2199 32.5142 13.4258 31.0266 13.4258C29.539 13.4258 28.3337 12.2199 28.3337 10.7323C28.3337 9.2447 29.539 8.03943 31.0266 8.03943C32.5142 8.03943 33.7201 9.24533 33.7201 10.7323Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0042 10.6986C31.2203 10.6986 31.3955 10.5234 31.3955 10.3073C31.3955 10.0911 31.2203 9.91589 31.0042 9.91589C30.788 9.91589 30.6128 10.0911 30.6128 10.3073C30.6128 10.5234 30.788 10.6986 31.0042 10.6986Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0507 10.2667C32.0507 10.6599 31.5671 11.6166 31.2574 12.188C31.1483 12.3893 30.8604 12.3893 30.752 12.188C30.4422 11.6166 29.958 10.6599 29.958 10.2667C29.958 9.68899 30.4267 9.22034 31.0044 9.22034C31.5821 9.22034 32.0507 9.68899 32.0507 10.2667Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.373922,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2221_16273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.7604,
    height: 39.7604,
    fill: "white",
    transform: "translate(0.424805 0.82959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/Visibility.64b5b8e41b57218ebaa064b2c546c50c.svg";
export { ForwardRef as ReactComponent };